<template>
  <section class="column">
    <div class="title-block">【凡例】</div>
    <div class="seat-guide">
      <div class="block">
        <div class="row">
          <div class="th cell">
            <img :src="require(`@/assets/img/icon/svg/icon-yes.svg`)" />
          </div>
          <div class="cell">空席に余裕があります</div>
        </div>
        <div class="row">
          <div class="th cell">
            <img :src="require(`@/assets/img/icon/svg/icon-little.svg`)" />
          </div>
          <div class="cell">空席が残りわずかです</div>
        </div>
        <div class="row">
          <div class="th cell">
            <img :src="require(`@/assets/img/icon/svg/icon-none.svg`)" />
          </div>
          <div class="cell">満席です</div>
        </div>
        <div class="row">
          <div class="th cell">前展望席</div>
          <div class="cell">（XX席）XXは空席数です</div>
        </div>
        <div class="row">
          <div
            class="th cell"
            :class="{ end: uniqueExclusiveTypes.length === 0 }"
          >
            <img
              :src="require(`@/assets/img/icon/png/child_care_icon.png`)"
              class="icon-size"
            />
          </div>
          <div class="cell" :class="{ end: uniqueExclusiveTypes.length === 0 }">
            子育て応援席が設定された列車です
          </div>
        </div>
        <div
          v-for="(exclusiveType, index) in uniqueExclusiveTypes"
          :key="index"
          class="row"
        >
          <div
            class="th cell"
            :class="{ end: index === uniqueExclusiveTypes.length - 1 }"
          >
            <img
              :src="require(`@/assets/img/icon/png/dummy_icon.png`)"
              class="icon-size"
            />
          </div>
          <div
            class="cell"
            :class="{ end: index === uniqueExclusiveTypes.length - 1 }"
          >
            {{ exclusiveType }}が設定された列車です
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from "vue";
import {
  hasOtherExclusiveType,
  getOtherExclusiveTypeName,
} from "@/utils/seatUtils";

export default {
  name: "MFITTSeatGuide",
  props: {
    trainLists: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const uniqueExclusiveTypes = computed(() => {
      const uniqueNames = new Set();

      if (props.trainLists) {
        Object.values(props.trainLists).forEach((list) => {
          if (hasOtherExclusiveType(list)) {
            const name = getOtherExclusiveTypeName(list);
            if (name && name.trim() !== "") {
              uniqueNames.add(name);
            }
          }
        });
      }

      return Array.from(uniqueNames);
    });

    return {
      uniqueExclusiveTypes,
    };
  },
};
</script>

<style lang="scss">
.column .title-block {
  font-weight: normal;
}
.seat-guide {
  width: 100%;
  padding: 0;
  margin: 0;
}
.seat-guide .block {
  display: table;
  width: 100%;
  font-size: 13px;
  line-height: 20px;
  font-weight: normal;
}
.seat-guide .row {
  display: table-row;
}
.seat-guide .cell {
  font-weight: normal;
  display: table-cell;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px;
}
.seat-guide .th {
  width: 60px;
  text-align: center;
  border-right: 1px solid #e0e0e0;
}
.seat-guide .end {
  border-bottom: none;
}
.icon-size {
  width: 20px;
}
</style>
